import React, { useContext } from 'react'
import styles from './Layout3.module.css'
import { ChooseContext } from '../../../../../utils/context'
import classNames from 'classnames'

export const Layout3 = () => {
  
  const {view, changeView} = useContext(ChooseContext)
  
  const wrapClassNames = classNames(styles.wrapper, {[styles.selected]: view === 3})

  return (
    <div className={wrapClassNames} onClick={() => changeView(3)}>
      <div className={styles.topRow}>
        <div className={styles.mainUser}></div>
        <div>
          <div className={styles.user}></div>
          <div className={styles.user}></div>
          <div className={styles.user}></div>
        </div>
      </div>
      <div className={styles.bottomRow}>
        <div className={styles.user}></div>
        <div className={styles.user}></div>
        <div className={styles.user}></div>
        <div className={styles.user}></div>
      </div>
    </div>
  )
}
